import { useContext } from 'react'
import { ConfirmModalContext } from './ConfirmModalProvider'

export function useConfirmModal() {
  const ctx = useContext(ConfirmModalContext)
  if (!ctx) {
    throw new Error('useConfirmModal must be used inside a ConfirmModalProvider')
  }
  return ctx
}
